<template>
  <div role="main" class="container">
    <div class="content-header">
      <div class="container"></div>
    </div>
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="confirmation-container">
              <div
                class="hero-icon mx-auto mb-4 d-flex align-items-center justify-content-center"
              >
                <i class="fa fa-check-circle"></i>
              </div>
              <h1 class="hero-title mb-2">
                ¡Listo! La encuesta ha sido enviada.
              </h1>
              <p class="hero-subtitle mx-auto mb-0">
                ¡Muchas gracias por su tiempo!
              </p>
              <p v-if="googleFormsUrl && countdown > 0" class="mt-3 text-muted">
                Redirigiendo a tu expediente automáticamente en
                <b>{{ countdown }}</b> segundos...
              </p>
              <a
                v-if="googleFormsUrl"
                @click="downloadExpediente"
                class="btn btn-primary btn-lg cta px-4 mt-4"
                style="border-radius: 0.8rem"
              >
                <i class="fas fa-file-download mr-2"></i>
                <span>Descargar Expediente</span>
              </a>
            </div>
            <a
              v-if="!googleFormsUrl"
              class="btn btn-primary btn-lg cta px-4"
              type="button"
              href="https://www.baessh.com.mx"
              style="border-radius: 0.8rem"
            >
              <i class="fas fa-globe mr-2"></i>
              <span>Visitar baessh.com.mx</span>
            </a>
            <hr />
            <div class="others-services-container">
              <div
                class="d-flex align-items-center justify-content-center justify-content-sm-start pb-3 pt-2"
              >
                <h2 class="section-title m-0">
                  Otros servicios que te podrían interesar
                </h2>
              </div>
              <div class="cards-wrap">
                <div class="row justify-content-center align-items-center g-2">
                  <div
                    class="col-12 col-sm-6 col-lg-4 mb-2 d-flex"
                    v-for="(card, idx) in cards"
                    :key="idx"
                  >
                    <a
                      class="service-card h-100"
                      :href="card.tourl"
                      target="_blank"
                      rel="noopener"
                    >
                      <div class="service-media">
                        <img
                          class="service-img"
                          :src="card.urlimg"
                          :alt="card.title"
                          loading="lazy"
                        />
                      </div>
                      <div class="service-body">
                        <h3 class="service-title mb-0">{{ card.title }}</h3>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="contact-container">
              <div class="contact mt-4 pt-4 text-center border-top">
                <button
                  class="btn btn-primary btn-lg cta px-4 mr-2"
                  type="button"
                  @click="goWhatsApp"
                  style="border-radius: 0.8rem"
                >
                  <i class="fab fa-whatsapp mr-2"></i>
                  <span>Contactar por WhatsApp</span>
                </button>
                <a
                  v-if="googleFormsUrl"
                  class="btn btn-primary btn-lg cta px-4"
                  type="button"
                  href="https://www.baessh.com.mx"
                  style="border-radius: 0.8rem"
                >
                  <i class="fas fa-globe mr-2"></i>
                  <span>Visitar baessh.com.mx</span>
                </a>
                <p class="contact-hint mt-3 mb-0">
                  ¿Tienes dudas? Escríbenos directamente.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    googleFormsUrl: {
      type: String,
      default: null,
    },
  },

  name: "ConfirmarEncuesta",
  data() {
    return {
      whatsappPhoneE164: "526677138632",
      countdown: 7,
      timer: null,
      cards: [
        {
          title: "Protección Civil",
          urlimg: "https://baessh.com.mx/img/email/servicios/img-s5.png",
          tourl: "https://baessh.com.mx/proteccion-civil",
        },
        {
          title: "Unidad de Inspección",
          urlimg: "https://baessh.com.mx/img/email/servicios/img-s4.png",
          tourl: "https://baessh.com.mx/unidad-inspeccion",
        },
        {
          title: "Seguridad e Higiene Industrial",
          urlimg: "https://baessh.com.mx/img/email/servicios/img-s1.png",
          tourl: "https://baessh.com.mx/seguridad-industrial",
        },
        {
          title: "Extintores y Equipos Contra Incendios",
          urlimg: "https://baessh.com.mx/img/email/servicios/img-s6.png",
          tourl: "https://baessh.com.mx/extintores",
        },
        {
          title: "Señalamientos de Seguridad",
          urlimg: "https://baessh.com.mx/img/email/servicios/img-s7.png",
          tourl: "https://baessh.com.mx/señalamientos",
        },
        {
          title: "Consultoría Ambiental",
          urlimg: "https://baessh.com.mx/img/email/servicios/img-s2.png",
          tourl: "https://baessh.com.mx/consultoria-ambiental",
        },
      ],
    };
  },
  mounted() {
    if (this.googleFormsUrl) {
      this.startCountdown();
    }
  },
  methods: {
    goWhatsApp() {
      const url = `https://wa.me/${this.whatsappPhoneE164}`;
      window.open(url, "_blank", "noopener");
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          this.downloadExpediente();
        }
      }, 1000);
    },
    downloadExpediente() {
      if (this.timer) clearInterval(this.timer);
      if (this.googleFormsUrl) {
        window.location.href = this.googleFormsUrl;
      }
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
};
</script>

<style>
.confirmation-container {
  margin: 7.5rem 0;
}
/* ====== Hero ====== */
.hero-icon {
  width: 96px;
  height: 96px;
  border-radius: 9999px;
  background: #dcfce7;
  color: #16a34a;
  font-size: 56px;
}
.page.theme-dark .hero-icon {
  background: rgba(20, 83, 45, 0.2);
  color: #4ade80;
}
.hero-title {
  font-weight: 800;
  letter-spacing: -0.02em;
  font-size: 32px;
  margin: 0;
}
@media (min-width: 576px) {
  .hero-title {
    font-size: 38px;
  }
}
.hero-subtitle {
  max-width: 640px;
  color: #556991;
  font-size: 18px;
  line-height: 1.6;
}
.page.theme-dark .hero-subtitle {
  color: #9ca3af;
}
.section-title {
  font-weight: 800;
  letter-spacing: -0.015em;
  font-size: 24px;
}
/* ====== Cards ====== */
.cards-wrap {
  max-width: 860px;
  margin: 0 auto;
}
.service-card {
  display: flex;
  flex-direction: column;
  text-decoration: none;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e6ecf5;
  transition: transform 200ms ease, box-shadow 200ms ease,
    border-color 200ms ease;
  overflow: hidden;
  width: 100%;
  max-width: 260px;
  margin: 0 auto;
}
.service-card:hover,
.service-card:focus-visible {
  transform: translateY(-3px);
  border-color: #d2dbea;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.12);
}
.service-media {
  background: #ffffff;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}
.service-img {
  width: 100%;
  height: 140px;
  object-fit: cover;
  display: block;
}
.service-body {
  padding: 16px;
}
.service-title {
  color: #0f172a;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.3;
}
.page.theme-dark .service-card {
  background: #0f172a;
  border-color: rgba(148, 163, 184, 0.2);
}
.page.theme-dark .service-media {
  background: rgba(148, 163, 184, 0.08);
}
.page.theme-dark .service-title {
  color: #e2e8f0;
}
/* ====== CTA ====== */
.btn-primary {
  background-color: #25417a !important;
  border-color: #25417a !important;
}
.btn-primary:hover {
  background-color: #1a3668 !important;
  border-color: #1a3668 !important;
}
.cta {
  min-width: 240px;
  border-radius: var(--radius-lg);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
}
.contact-hint {
  color: var(--text-muted);
  font-weight: 600;
  font-size: 13px;
}
.page.theme-dark .contact-hint {
  color: #6b7280;
}
</style>
